import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { ContentsApi } from 'api';
import { ContentsPageType, SearchContentsQueryType } from 'types';

function useGetAll({
  ...query
}: SearchContentsQueryType & {
  pageType: ContentsPageType;
}) {
  return useAuthQuery(
    getQueryKeys(KEY).list({ ...query }),
    () => ContentsApi.getAll(query),
    {
      select: (data) => data.data,
    },
  );
}

export default useGetAll;
